import { IDataPackageFileDescriptor, IUploader } from '@vivli/shared/features/data-package/infrastructure/interface';
import { DataPackageTypeEnum } from '@vivli/features/studies/infrastructure/enum';
import { useAuthServiceContext } from '@vivli/core/infrastructure/context';
import { UploaderView } from '@vivli/shared/features/data-package/views';

interface UploaderProps extends IUploader {
    files?: IDataPackageFileDescriptor[];
    preExistingFiles?: IDataPackageFileDescriptor[];
    isLoading?: boolean;
    scrollEnabled?: boolean;
    packageType?: DataPackageTypeEnum;
    readonly?: boolean;
    secondaryFilesToShow?: IDataPackageFileDescriptor[];
    hybridMode?: boolean;
}

export const DataPackageUploaderComponent = (props: UploaderProps) => {
    const { getTokenSilent } = useAuthServiceContext();

    return <UploaderView {...props} refreshApiToken={getTokenSilent} />;
};
